import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import AppLayout from '../components/AppLayout';
import PageTitle from '../components/PageTitle';
import { AdBannerResponsive } from '../components/GoogleAdsense';
import ProductCarousel from '../components/affiliate/ProductCarousel';
import '../styles/pages/TermsPage.css';

const TermsPage = () => {
  const location = useLocation();

  useEffect(() => {
    document.title = '利用規約 | つむぎ';

    // URLハッシュがあれば該当セクションにスクロール
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location]);

  return (
    <AppLayout>
      <PageTitle
        title="利用規約"
        subtitle="Terms of Service"
        icon="📄"
      />

      <div className="tsumugi-container py-6">
        <div className="tsumugi-card">
          <div className="terms-content-wrapper">
            <p className="terms-last-updated">
              最終更新日: 2026年1月
            </p>

            {/* 医療免責事項 - 最重要事項として最初に配置 */}
            <section id="medical-disclaimer" className="terms-medical-disclaimer">
              <h2>
                🏥 医療免責事項
              </h2>
              <div className="terms-medical-disclaimer-content">
                <p className="terms-medical-disclaimer-intro">
                  本サービスは医療行為ではありません。
                </p>
                <ul className="terms-medical-disclaimer-list">
                  <li>本サービスは、橋本病（甲状腺機能低下症）の方向けの栄養・食事に関する情報提供および参考アドバイスを目的としたサービスです。</li>
                  <li>本サービスは、医師による診断、治療、処方箋の発行、医療行為の代替となるものではありません。</li>
                  <li>本サービスで提供される情報およびアドバイスは、参考情報としてご利用いただくものであり、個別の医学的判断を行うものではありません。</li>
                  <li>病状の診断、治療方針の決定、薬の調整、血液検査結果の医学的解釈については、必ず医師にご相談ください。</li>
                  <li>本サービスの利用によって得られた情報に基づいて行われた一切の行動について、当サービスは責任を負いかねます。</li>
                  <li>体調に異変を感じた場合、または症状が悪化した場合は、直ちに医療機関を受診してください。</li>
                </ul>
                <p className="terms-medical-disclaimer-footer">
                  本サービスは、医師の治療を補完する栄養面でのサポートツールとしてご活用ください。
                </p>
              </div>
            </section>

            <section className="terms-section">
              <h2>
                第1条（適用）
              </h2>
              <p className="terms-section-text">
                本利用規約（以下「本規約」といいます）は、つむぎ（以下「本サービス」といいます）の利用条件を定めるものです。
                登録ユーザーの皆さま（以下「ユーザー」といいます）には、本規約に従って本サービスをご利用いただきます。
              </p>
            </section>

            <section className="terms-section">
              <h2>
                第2条（利用登録）
              </h2>
              <ol className="terms-ordered-list">
                <li className="terms-ordered-list-item">
                  本サービスの利用を希望する方は、本規約に同意の上、当サービスの定める方法によって利用登録を申請し、当サービスがこれを承認することによって利用登録が完了するものとします。
                </li>
                <li className="terms-ordered-list-item">
                  当サービスは、利用登録の申請者に以下の事由があると判断した場合、利用登録の申請を承認しないことがあります。
                  <ul className="terms-nested-list">
                    <li>利用登録の申請に際して虚偽の事項を届け出た場合</li>
                    <li>本規約に違反したことがある者からの申請である場合</li>
                    <li>その他、当サービスが利用登録を相当でないと判断した場合</li>
                  </ul>
                </li>
              </ol>
            </section>

            <section className="terms-section">
              <h2>
                第3条（ユーザーIDおよびパスワードの管理）
              </h2>
              <ol className="terms-ordered-list">
                <li className="terms-ordered-list-item">
                  ユーザーは、自己の責任において、本サービスのユーザーIDおよびパスワードを適切に管理するものとします。
                </li>
                <li className="terms-ordered-list-item">
                  ユーザーは、いかなる場合にも、ユーザーIDおよびパスワードを第三者に譲渡または貸与し、もしくは第三者と共用することはできません。
                </li>
                <li className="terms-ordered-list-item">
                  当サービスは、ユーザーIDとパスワードの組み合わせが登録情報と一致してログインされた場合には、そのユーザーIDを登録しているユーザー自身による利用とみなします。
                </li>
              </ol>
            </section>

            <section className="terms-section">
              <h2>
                第4条（料金および支払方法）
              </h2>
              <ol className="terms-ordered-list">
                <li className="terms-ordered-list-item">
                  ユーザーは、本サービスの有料部分の対価として、当サービスが別途定める料金を、当サービスが指定する方法により支払うものとします。
                </li>
                <li className="terms-ordered-list-item">
                  ユーザーが料金の支払を遅滞した場合には、ユーザーは年14.6％の割合による遅延損害金を支払うものとします。
                </li>
              </ol>
            </section>

            <AdBannerResponsive />

            <section className="terms-section">
              <h2>
                第5条（禁止事項）
              </h2>
              <p className="terms-section-paragraph">
                ユーザーは、本サービスの利用にあたり、以下の行為をしてはなりません。
              </p>
              <ul className="terms-unordered-list">
                <li className="terms-unordered-list-item">法令または公序良俗に違反する行為</li>
                <li className="terms-unordered-list-item">犯罪行為に関連する行為</li>
                <li className="terms-unordered-list-item">当サービス、他のユーザー、または第三者の知的財産権、肖像権、プライバシー、名誉その他の権利または利益を侵害する行為</li>
                <li className="terms-unordered-list-item">当サービスのネットワークまたはシステム等に過度な負荷をかける行為</li>
                <li className="terms-unordered-list-item">本サービスの運営を妨害するおそれのある行為</li>
                <li className="terms-unordered-list-item">不正アクセスをし、またはこれを試みる行為</li>
                <li className="terms-unordered-list-item">他のユーザーに関する個人情報等を収集または蓄積する行為</li>
                <li className="terms-unordered-list-item">不正な目的を持って本サービスを利用する行為</li>
                <li className="terms-unordered-list-item">本サービスの他のユーザーまたはその他の第三者に不利益、損害、不快感を与える行為</li>
                <li className="terms-unordered-list-item">他のユーザーに成りすます行為</li>
                <li className="terms-unordered-list-item">当サービスが許諾しない本サービス上での宣伝、広告、勧誘、または営業行為</li>
                <li className="terms-unordered-list-item">本サービスを医療行為または医学的判断の代替として利用する行為</li>
                <li className="terms-unordered-list-item">その他、当サービスが不適切と判断する行為</li>
              </ul>
            </section>

            <section className="terms-section">
              <h2>
                第6条（本サービスの提供の停止等）
              </h2>
              <ol className="terms-ordered-list">
                <li className="terms-ordered-list-item">
                  当サービスは、以下のいずれかの事由があると判断した場合、ユーザーに事前に通知することなく本サービスの全部または一部の提供を停止または中断することができるものとします。
                  <ul className="terms-nested-list">
                    <li>本サービスにかかるコンピュータシステムの保守点検または更新を行う場合</li>
                    <li>地震、落雷、火災、停電または天災などの不可抗力により、本サービスの提供が困難となった場合</li>
                    <li>コンピュータまたは通信回線等が事故により停止した場合</li>
                    <li>その他、当サービスが本サービスの提供が困難と判断した場合</li>
                  </ul>
                </li>
                <li className="terms-ordered-list-item">
                  当サービスは、本サービスの提供の停止または中断により、ユーザーまたは第三者が被ったいかなる不利益または損害についても、一切の責任を負わないものとします。
                </li>
              </ol>
            </section>

            <section className="terms-section">
              <h2>
                第7条（保証の否認および免責事項）
              </h2>
              <ol className="terms-ordered-list">
                <li className="terms-ordered-list-item">
                  当サービスは、本サービスに事実上または法律上の瑕疵（安全性、信頼性、正確性、完全性、有効性、特定の目的への適合性、セキュリティなどに関する欠陥、エラーやバグ、権利侵害などを含みます。）がないことを明示的にも黙示的にも保証しておりません。
                </li>
                <li className="terms-ordered-list-item">
                  当サービスは、本サービスに起因してユーザーに生じたあらゆる損害について一切の責任を負いません。ただし、本サービスに関する当サービスとユーザーとの間の契約（本規約を含みます。）が消費者契約法に定める消費者契約となる場合、この免責規定は適用されません。
                </li>
                <li className="terms-ordered-list-item">
                  当サービスは、本サービスによって提供される栄養・食事に関する情報の正確性、有効性について保証するものではなく、当該情報に基づいてユーザーが行った一切の行動について責任を負いません。
                </li>
              </ol>
            </section>

            <section className="terms-section">
              <h2>
                第8条（利用規約の変更）
              </h2>
              <p className="terms-section-text">
                当サービスは、必要と判断した場合には、ユーザーに通知することなくいつでも本規約を変更することができるものとします。
                なお、本規約の変更後、本サービスの利用を開始した場合には、当該ユーザーは変更後の規約に同意したものとみなします。
              </p>
            </section>

            <section className="terms-section">
              <h2>
                第9条（個人情報の取扱い）
              </h2>
              <p className="terms-section-text">
                当サービスは、本サービスの利用によって取得する個人情報については、当サービス「プライバシーポリシー」に従い適切に取り扱うものとします。
              </p>
            </section>

            <section className="terms-section">
              <h2>
                第10条（通知または連絡）
              </h2>
              <p className="terms-section-text">
                ユーザーと当サービスとの間の通知または連絡は、当サービスの定める方法によって行うものとします。
                当サービスは、ユーザーから、当サービスが別途定める方式に従った変更届け出がない限り、現在登録されている連絡先が有効なものとみなして当該連絡先へ通知または連絡を行い、これらは、発信時にユーザーへ到達したものとみなします。
              </p>
            </section>

            <section className="terms-section">
              <h2>
                第11条（準拠法・裁判管轄）
              </h2>
              <ol className="terms-ordered-list">
                <li className="terms-ordered-list-item">本規約の解釈にあたっては、日本法を準拠法とします。</li>
                <li className="terms-ordered-list-item">本サービスに関して紛争が生じた場合には、当サービスの本店所在地を管轄する裁判所を専属的合意管轄とします。</li>
              </ol>
            </section>

            <p className="terms-footer-text">
              以上
            </p>
          </div>
        </div>
        <AdBannerResponsive />
        <ProductCarousel location="terms" />
      </div>
    </AppLayout>
  );
};

export default TermsPage;
